quoteModule.factory('vehicleProductCoordService',['$filter','SingleProductCoordinationInfo', function ($filter, SingleProductCoordinationInfo) {
    var vehProductCoordService = {};

    /*
    This service handle coordinating all of the coverages, deductibles, upgrades, etc. for products returned from the
    main product retrieval service. It keeps track of whether the product has upgrades or not,
     */
    var vehicleProductsData = {};
    var vehicleDetails = {};
    //hold the vehicle data
    vehProductCoordService.collectVehicleDetails = function(veh) {
        vehicleDetails = veh;
    }
    //return the vehicle data
    vehProductCoordService.getVehicleDetails = function() {
        return vehicleDetails;
    }
    //hold a single product as a new product data entry
    vehProductCoordService.collectSingleProductData = function(prodData, cachedResponseId){
        if (prodData == null){
            return null;
        }
        var prodEntry = new SingleProductCoordinationInfo();
        prodEntry.fullProductData = prodData;
        prodEntry.availableCoverages = prodData.ProductCoverages != null ? prodData.ProductCoverages : null;
        prodEntry.productFlags.hasCoverages =  prodData.ProductCoverages!=null && prodData.ProductCoverages.length > 0;
        prodEntry.productFlags.hasDeductibles = prodData.CoverageDeductibles!=null && prodData.CoverageDeductibles.length > 0;
        prodEntry.productFlags.isIncomplete = false;
        prodEntry.productFlags.hasSurcharges = 'waiting';
        //check to see if the partner says that we need more "info" to rate a product
        // usually financial data
        if (prodData.PartnerSpecificFields != null && prodData.PartnerSpecificFields.FlexFields != null){
            var incompleteProd = $filter('filter')(prodData.PartnerSpecificFields.FlexFields, {"FieldName": "IncompleteProduct"});
            if (incompleteProd && incompleteProd.length == 1){
                prodEntry.productFlags.isIncomplete = true;
                prodData.PartnerSpecificFields.FlexFields.forEach(function(field){
                    if (field.FieldName.toUpperCase().indexOf('NECESSARYFIELD') >= 0){
                        prodEntry.incompleteFields.push(field.FieldValue);
                    }
                });
            }
        }
        prodEntry.cachedResponseId = cachedResponseId;
        vehicleProductsData[prodData.InternalProductId] = prodEntry;

        return prodEntry;
    }
    //from the identifiers chosen, build the product to rate (rated product, coverage, deductible, etc.)
    vehProductCoordService.buildProductToRate = function(prodid, coverageid, deductibleid, optionvals,
             baseuptermid, upgradeprodid, upgradecoverageid, upgradedeductibleid, upgradeoptionvals){
        //make a clone of the product before we send this to the rating API
        var prodToRate = angular.copy(vehicleProductsData[prodid].fullProductData);

        //find the coverage
        var coverageToRate = null;
        var baseTermToRate = null;
        for (var i=0; coverageToRate==null && i < prodToRate.ProductCoverages.length; i++) {
            if (prodToRate.ProductCoverages[i].ProductCoverage.InternalCoverageId === coverageid){
                coverageToRate = prodToRate.ProductCoverages[i];

                for (var j=0; baseuptermid && baseTermToRate==null && j < coverageToRate.ProductTerms.length; j++){
                    if (coverageToRate.ProductTerms[j].ProductTerm.InternalTermId == baseuptermid){
                        baseTermToRate = coverageToRate.ProductTerms[j];
                    }
                }
            }
        }

        if (baseTermToRate){
            coverageToRate.ProductTerms = [baseTermToRate];
            //we need to make sure we only request the "base term to rate" if we are doing "upgradable" products
            prodToRate.UpgradeProducts[0].BaseNoUpgradeProduct.ProductCoverages[0].ProductTerms = [baseTermToRate];
        }

        //find the deductible
        var deductibleToRate = null;
        for (var j=0; coverageToRate!=null && coverageToRate.CoverageDeductibles!= null && deductibleToRate == null && j < coverageToRate.CoverageDeductibles.length; j++){
           if (coverageToRate.CoverageDeductibles[j].ProductDeductible.InternalDeductibleId === deductibleid){
               deductibleToRate = coverageToRate.CoverageDeductibles[j];
           }
        }

        //grab the options we need to rate
        var optionsToRate = [];
        for (var k=0; optionvals!=null && k < optionvals.length; k++)
        {
            if (optionvals[k]) {
                var opts = $filter('filter')(prodToRate.ProductOptions, {"InternalOptionId": optionvals[k]});
                if (opts && opts.length > 0) { optionsToRate.push(opts[0]); }
            }
        }
        prodToRate.ProductOptions = optionsToRate;
        //for products that are "upgradeable"
        if (upgradecoverageid && upgradecoverageid.length > 0){
            var upgdCoverageToRate = null;
            for (var i=0; upgdCoverageToRate==null && i < prodToRate.UpgradeProducts[0].ProductCoverages.length; i++) {
                if (prodToRate.UpgradeProducts[0].ProductCoverages[i].ProductCoverage.InternalCoverageId === upgradecoverageid){
                    upgdCoverageToRate = prodToRate.UpgradeProducts[0].ProductCoverages[i];
                    //some products have more than one base term to rate.. need to choose the correct one
                    upgdCoverageToRate.ProductTerms = null;
                    upgdCoverageToRate.ProductTerms = [baseTermToRate];
                }
            }
            //find the deductible
            var upgdDeductibleToRate = null;
            for (var j=0; upgdCoverageToRate!=null && upgdDeductibleToRate == null && upgdCoverageToRate.CoverageDeductibles!= null &&  j < upgdCoverageToRate.CoverageDeductibles.length; j++){
                if (upgdCoverageToRate.CoverageDeductibles[j].ProductDeductible.InternalDeductibleId === upgradedeductibleid){
                    upgdDeductibleToRate = upgdCoverageToRate.CoverageDeductibles[j];
                }
            }
            //grab the options we need to rate
            var upgdOptionsToRate = [];
            for (var k=0; upgradeoptionvals!=null && k < upgradeoptionvals.length; k++)
            {
                var opts = $filter('filter')(prodToRate.UpgradeProducts[0].ProductOptions, {"InternalOptionId": upgradeoptionvals[k]});
                upgdOptionsToRate.push(opts[0]);
            }
            prodToRate.UpgradeProducts[0].ProductOptions = upgdOptionsToRate;

            if (upgdCoverageToRate!=null && upgdDeductibleToRate!=null){
                upgdCoverageToRate.CoverageDeductibles = [upgdDeductibleToRate];
            }
            if (upgdCoverageToRate !=null){
                prodToRate.UpgradeProducts[0].ProductCoverages = [upgdCoverageToRate];
            }
        }

        //setup the arrays
        if (coverageToRate !=null && deductibleToRate!=null)
            coverageToRate.CoverageDeductibles = [deductibleToRate];
        if (coverageToRate != null)
            prodToRate.ProductCoverages = [coverageToRate];
        else
            prodToRate = null;

        return prodToRate;
    }
    //get the product data held by identifier
    vehProductCoordService.getProductData = function(prodid) {
        if (typeof(vehicleProductsData[prodid]) == 'undefined'){
            return null;
        }
        return vehicleProductsData[prodid];
    }
    //reset all of the product data
    vehProductCoordService.clearProductData = function() {
        vehicleProductsData = {};
    }
    //get all of the product data
    vehProductCoordService.allProductData = function() {
        var curProducts = [];
        for (var key in vehicleProductsData){
            curProducts.push(vehicleProductsData[key].fullProductData);
        }
        return curProducts;
    }
    //get coverage lists by product id
    vehProductCoordService.getAvailableCoverages = function(prodid){
        if (typeof(vehicleProductsData[prodid]) == 'undefined'){
            return null;
        }
        return vehicleProductsData[prodid].availableCoverages;
    }
    //get product flags (has coverages, deductibles, etc)
    vehProductCoordService.getProductFlags = function(prodid){
        if (typeof(vehicleProductsData[prodid]) == 'undefined'){
            return null;
        }
        return vehicleProductsData[prodid].productFlags;
    }
    //select the product and coverage, so we set up the deductibles
    vehProductCoordService.selectCoverage = function(prodid, coverageid){
        if (typeof(vehicleProductsData[prodid]) == 'undefined'){
            return null;
        }
        var selectedProd = vehicleProductsData[prodid];
        //set the deductibles and base no upgrade terms
        vehicleProductsData[prodid].availableDeductibles = [];
        vehicleProductsData[prodid].availableCoverages.forEach(function(cov) {
            if (cov.ProductCoverage.InternalCoverageId === coverageid){
                vehicleProductsData[prodid].availableDeductibles = cov.CoverageDeductibles;
                vehicleProductsData[prodid].productFlags.hasDeductibles = cov.CoverageDeductibles != null &&
                    cov.CoverageDeductibles.length > 0;
                //for those products that have base terms and upgrades
                vehicleProductsData[prodid].baseNoUpgradeTerms = cov.ProductTerms;
                vehicleProductsData[prodid].productFlags.hasUpgrades = selectedProd.fullProductData.UpgradeProducts && selectedProd.fullProductData.UpgradeProducts.length > 0;
            }
        });
        //set the product options
        vehicleProductsData[prodid].availableOptions = [];

        //look at options
        for (var j=0; selectedProd.fullProductData.ProductOptions!=null && j < selectedProd.fullProductData.ProductOptions.length;j++){
            var hasFlex = selectedProd.fullProductData.ProductOptions[j].PartnerSpecificFields && selectedProd.fullProductData.ProductOptions[j].PartnerSpecificFields.FlexFields;
            var covField = null;
            if (hasFlex){
                var covFields = $filter('filter')(selectedProd.fullProductData.ProductOptions[j].PartnerSpecificFields.FlexFields, {"FieldName": "applicableCoverageId"});
                if (covFields && covFields.length == 1) {
                    covField = covFields[0].FieldValue;
                }
            }
            //for those options that only apply to product, we show them regardless
            if (!(hasFlex && covField)){
                vehicleProductsData[prodid].availableOptions.push(selectedProd.fullProductData.ProductOptions[j]);
            }
            //if we have an "availableCoverageId", we only add the product option if it matches
            else if (covField === coverageid) {
                vehicleProductsData[prodid].availableOptions.push(selectedProd.fullProductData.ProductOptions[j]);
            }
        }
        vehicleProductsData[prodid].productFlags.hasSurcharges = vehicleProductsData[prodid].availableOptions.length > 0 ? 'yes' : 'no';
        return;
    }
    //select the base lw term - starts the "upgrade" process
    vehProductCoordService.selectBaseNoUpgradeTerm = function(prodid, noupgradetermid){
        if (typeof(vehicleProductsData[prodid]) == 'undefined'){
            return null;
        }

        var selectedProd = vehicleProductsData[prodid];

        if (selectedProd.fullProductData.UpgradeProducts && selectedProd.fullProductData.UpgradeProducts.length > 0){
            var cloneUpgrade = angular.copy(selectedProd.upgradeProducts[0]);
            selectedProd.upgradeProducts = [];

            selectedProd.fullProductData.UpgradeProducts.forEach(function(upProd){
                if (upProd.BaseNoUpgradeProduct && upProd.BaseNoUpgradeProduct.ProductCoverages && upProd.BaseNoUpgradeProduct.ProductCoverages[0] &&
                    upProd.BaseNoUpgradeProduct.ProductCoverages[0].ProductTerms){

                    upProd.BaseNoUpgradeProduct.ProductCoverages[0].ProductTerms.forEach(function(baseTerm){
                        //some products have more than one rating base term
                        if (baseTerm.ProductTerm.InternalTermId == noupgradetermid) {
                            var nxtUpgrade = angular.copy(cloneUpgrade);
                            var nxtUpProd = angular.copy(upProd);

                            nxtUpProd.BaseNoUpgradeProduct.ProductCoverages[0].ProductTerms = [baseTerm];

                            nxtUpgrade.upgradeProductId = nxtUpProd.InternalProductId;
                            nxtUpgrade.upgradeProductName = nxtUpProd.DisplayName;
                            nxtUpgrade.upgradeCoverages = nxtUpProd.ProductCoverages != null ? nxtUpProd.ProductCoverages : null;
                            nxtUpgrade.upgradeProdFull = nxtUpProd;

                            selectedProd.upgradeProducts.push(nxtUpgrade);
                        }
                    })
                }}
            );
        }
        else{
            selectedProd.upgradeProducts = null;
        }
    }
    //get the available upgrade product id.. assuming for now there will only be 1 upgrade product
    vehProductCoordService.getUpgradeProductId = function(prodid){
        if (typeof(vehicleProductsData[prodid]) == 'undefined'){
            return null;
        }

        var selectedProd = vehicleProductsData[prodid];
        if (selectedProd.upgradeProducts){
            //assuming for now upgrades are a single product
            return selectedProd.upgradeProducts[0].upgradeProductId;
        }
        else{
            return null;
        }
    }
    //retrieve upgrade coverages by product ids
    vehProductCoordService.getAvailableUpgradeCoverages = function(prodid, upgradeProdId){
        if (typeof(vehicleProductsData[prodid]) == 'undefined'){
            return null;
        }

        var upgradeProduct = $filter('filter')(vehicleProductsData[prodid].upgradeProducts, {"upgradeProductId": upgradeProdId});
        if (!(upgradeProduct && upgradeProduct.length > 0) ){
            throw new Error('Could not find upgrade product: ' + upgradeProdId);
        }
        upgradeProduct = upgradeProduct[0];

        return upgradeProduct.upgradeCoverages;
    }
    //very similar to selecting a primary coverage.. getting upgrade deductibles and options
    vehProductCoordService.selectUpgradeCoverage = function(prodid, upgradeProdId, coverageid){
        if (typeof(vehicleProductsData[prodid]) == 'undefined'){
            return null;
        }

        var upgradeProduct = $filter('filter')(vehicleProductsData[prodid].upgradeProducts, {"upgradeProductId": upgradeProdId});
        if (!(upgradeProduct && upgradeProduct.length > 0)){
            throw new Error('Could not find upgrade product: ' + upgradeProdId);
        }
        upgradeProduct = upgradeProduct[0];
        vehicleProductsData[prodid].productFlags.hasUpgradeDeductibles = false;
        //set the deductibles
        upgradeProduct.upgradeDeductibles = [];
        upgradeProduct.upgradeCoverages.forEach(function(cov) {
            if (cov.ProductCoverage.InternalCoverageId === coverageid){
                upgradeProduct.upgradeDeductibles = cov.CoverageDeductibles;
            }
        });
        vehicleProductsData[prodid].productFlags.hasUpgradeDeductibles = upgradeProduct.upgradeDeductibles != null && upgradeProduct.upgradeDeductibles.length > 0;

        //set the product options
        upgradeProduct.upgradeOptions = [];
        //look at options
        for (var j=0; upgradeProduct.upgradeProdFull.ProductOptions!=null && j < upgradeProduct.upgradeProdFull.ProductOptions.length;j++){
            var hasFlex = upgradeProduct.upgradeProdFull.ProductOptions[j].PartnerSpecificFields && upgradeProduct.upgradeProdFull.ProductOptions[j].PartnerSpecificFields.FlexFields;
            var covField = null;
            if (hasFlex){
                var covFields = $filter('filter')(upgradeProduct.upgradeProdFull.ProductOptions[j].PartnerSpecificFields.FlexFields, {"FieldName": "applicableCoverageId"});
                if (covFields && covFields.length == 1) {
                    covField = covFields[0].FieldValue;
                }
            }
            //for those options that only apply to product, we show them regardless
            if (!(hasFlex && covField)){
                upgradeProduct.upgradeOptions.push(upgradeProduct.upgradeProdFull.ProductOptions[j]);
            }
            //if we have an "availableCoverageId", we only add the product option if it matches
            else if (covField === coverageid) {
                upgradeProduct.upgradeOptions.push(upgradeProduct.upgradeProdFull.ProductOptions[j]);
            }
        }

        return;
    }
    //get the available base lw terms
    vehProductCoordService.getAvailableBaseTerms = function(prodid){
        if (typeof(vehicleProductsData[prodid]) == 'undefined'){
            return null;
        }
        var selectedProd = vehicleProductsData[prodid];
        return selectedProd.baseNoUpgradeTerms;
    }
    //get the available deductibles for a product
    vehProductCoordService.getAvailableDeductibles = function(prodid){
        if (typeof(vehicleProductsData[prodid]) == 'undefined'){
            return null;
        }
        return vehicleProductsData[prodid].availableDeductibles;
    }
    //get the available product options for a product
    vehProductCoordService.getAvailableProductOptions = function(prodid){
        if (typeof(vehicleProductsData[prodid]) == 'undefined'){
            return null;
        }
        return vehicleProductsData[prodid].availableOptions;
    }
    //get available upgrade deductibles
    vehProductCoordService.getUpgradeDeductibles = function(prodid, upgradeProdId){
        if (typeof(vehicleProductsData[prodid]) == 'undefined'){
            return null;
        }
        var upgradeProduct = $filter('filter')(vehicleProductsData[prodid].upgradeProducts, {"upgradeProductId": upgradeProdId});
        if (!(upgradeProduct && upgradeProduct.length > 0)){
            throw new Error('Could not find upgrade product: ' + upgradeProdId);
        }
        upgradeProduct = upgradeProduct[0];

        return upgradeProduct.upgradeDeductibles;
    }
    //get available upgrade product options
    vehProductCoordService.getUpgradeProductOptions = function(prodid, upgradeProdId){
        if (typeof(vehicleProductsData[prodid]) == 'undefined'){
            return null;
        }
        var upgradeProduct = $filter('filter')(vehicleProductsData[prodid].upgradeProducts, {"upgradeProductId": upgradeProdId});
        if (!(upgradeProduct && upgradeProduct.length > 0)){
            throw new Error('Could not find upgrade product: ' + upgradeProdId);
        }
        upgradeProduct = upgradeProduct[0];

        return upgradeProduct.upgradeOptions;
    }


    return vehProductCoordService;
}]);